// Token acquisition helpers. `msalInstance` and `msalConfig` live in
// `./msal-instance` to avoid a circular import via `index.tsx` — see
// `msal-instance.ts` for the rationale.
import { msalConfig, msalInstance } from './msal-instance'

export { msalConfig }

export const getUserEmail = async () => {
  const account = msalInstance.getActiveAccount()
  return account?.username
}

export const getUsername = async () => {
  const account = msalInstance.getActiveAccount()
  return account?.name
}

export const getToken = async () => {
  // MSAL v3 requires initialize() to resolve before any other API call.
  // Route loaders fire during webpack evaluation, before index.tsx's
  // .initialize().then(...) has settled — so await it here. The call is
  // idempotent: subsequent invocations return the same promise.
  await msalInstance.initialize()

  const tokenRequest = {
    scopes: ['User.Read'],
    account: msalInstance.getActiveAccount() ?? undefined,
    forceRefresh: true,
  }

  try {
    const response = await msalInstance.acquireTokenSilent(tokenRequest)
    return response
  } catch (error) {
    console.error('Silent token acquisition failed:', error)
    // Outbound leg of the AAD round-trip: flag it so the tenant bootstrap
    // doesn't clear/re-pick the tenant on the way out or back. `index.tsx`
    // clears this once `handleRedirectPromise()` settles on the return leg.
    sessionStorage.setItem('authRedirectInProgress', 'true')
    msalInstance.acquireTokenRedirect(tokenRequest)
  }
  return null
}
